import transformBackgroundImage from 'libs/wordpress/utils/transformBackgroundImage';
import transformButtons from 'libs/wordpress/utils/transformButtons';
/**
 * Transforms data from text-section-repeater
 * @param {object[]} data - Array of text-section objects.
 * @param {object[]} - Transformed link data.
 */

export default data => {
    // Just return undefined if we don't have any data
    if (!data) {
        return undefined;
    }

    // Return the transformed data.
    return data.map(textSection => {
        const { layout } = textSection;
        if (layout === 'heading' || layout === 'sub_heading' || layout === 'sub-heading') {
            return {
                heading: textSection.heading.text,
                headingTag: textSection.heading.type,
                layout: layout === 'sub_heading' || layout === 'sub-heading' ? 'subHeading' : 'heading',
            };
        }
        if (layout === 'image') {
            const transformedImage = transformBackgroundImage(textSection.background_image);

            return {
                image: transformedImage,
                layout: 'image',
            };
        }
        if (layout === 'buttons') {
            const transformedButtons = transformButtons(textSection.buttons);

            return {
                buttons: transformedButtons,
                layout: 'buttons',
            };
        }
        return {
            text: textSection[layout],
            ...(layout === 'image' || layout === 'buttons' ? textSection[layout] : {}),
            layout,
        };
    });
};
